import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container, CloseButton, Top, NavList, NavItem, NavLink } from './styles'
import Logo from '../logo'

class Menu extends Component {
  componentDidUpdate() {
    const { show } = this.props

    if (!!show) document.body.style.overflow = 'hidden'
    else if (!show) document.body.style.overflow = 'unset'
  }

  render() {
    const { show, toggle } = this.props

    return (
      <Container show={show}>
        <Top>
          <Logo />
          <CloseButton onClick={toggle} aria-label="Close Menu">&#10005;</CloseButton>
        </Top>

        <NavList>
          <NavItem>
            <NavLink to="/" activeClassName="active">Home</NavLink>
          </NavItem>

          <NavItem>
            <NavLink to="/rooms-and-facilities" activeClassName="active">Rooms and Facilities</NavLink>
          </NavItem>

          <NavItem>
            <NavLink to="/guest-comments" activeClassName="active">Guest Comments</NavLink>
          </NavItem>

          <NavItem>
            <NavLink to="/contact-us" activeClassName="active">Contact Us</NavLink>
          </NavItem>
        </NavList>
      </Container>
    )
  }
}

Menu.propTypes = {
  show: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
}

export default Menu
